import React from 'react';

export type ClickOutsideHandler = (event: MouseEvent | TouchEvent) => void;

export default function useOnClickOutside<E extends HTMLElement>(
  ref: React.RefObject<E | null>,
  handler: ClickOutsideHandler
) {
  const callbackRef = React.useRef<ClickOutsideHandler | null>(null);
  callbackRef.current = handler;

  React.useEffect(() => {
    const listener: ClickOutsideHandler = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (
        !ref.current ||
        ref.current.contains(event.target as Node) ||
        !callbackRef.current
      ) {
        return;
      }

      callbackRef.current(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, callbackRef]);
}
